import { handleActions, combineActions } from 'redux-actions';
import { combineReducers } from 'redux';
import * as actionTypes from './constants';

export const users = handleActions(
  {
    [actionTypes.FETCH_USERS_SUCCESS]: (state, { payload }) => ({
      ...state,
      [payload.dropdownId]: payload.results,
    }),
    [actionTypes.FETCH_USERS_RESTRICTED_SUCCESS]: (state, { payload }) => ({
      ...state,
      [payload.dropdownId]: payload.results.items,
    }),
    [actionTypes.CLEAR_USERS_DATA]: (state, { payload }) => {
      const stateCopy = { ...state };
      delete stateCopy[payload.dropdownId];
      return stateCopy;
    },
    [combineActions(
      actionTypes.FETCH_USERS,
      actionTypes.FETCH_USERS_FAILURE,
      actionTypes.FETCH_RESTRICTED_USERS,
      actionTypes.FETCH_USERS_RESTRICTED_FAILURE,
    )]: (
      state,
      { payload },
    ) => ({
      ...state,
      [payload.dropdownId]: [],
    }),
  },
  {},
);

export const loading = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_USERS,
      actionTypes.FETCH_RESTRICTED_USERS,
    )]: (state, { payload }) => ({ ...state, [payload.dropdownId]: true }),
    [combineActions(
      actionTypes.FETCH_USERS_SUCCESS,
      actionTypes.FETCH_USERS_RESTRICTED_SUCCESS,
    )]: (state, { payload }) => ({
      ...state,
      [payload.dropdownId]: false,
    }),
    [combineActions(
      actionTypes.FETCH_USERS_FAILURE,
      actionTypes.FETCH_USERS_RESTRICTED_FAILURE,
    )]: (state, { payload }) => ({
      ...state,
      [payload.dropdownId]: false,
    }),
    [actionTypes.CLEAR_USERS_DATA]: (state, { payload }) => {
      const stateCopy = { ...state };
      delete stateCopy[payload.dropdownId];
      return stateCopy;
    },
  },
  {},
);

export default combineReducers({
  users,
  loading,
});
